import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpResponse} from '@angular/common/http/src/response';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs';

import {ConstantService} from '../../constant/constant.service';

/**
 * Description of Reportschemas Service
 *
 * @author [DEVELOPER NAME]
 */

@Injectable({
  providedIn: 'root'
})   
export class ReportschemasService {

  constructor(
    private constantService: ConstantService,
    private http: HttpClient
  ) {
  }

  private _items: any = {};
  
  setItem(item: any) {
    this._items = item;
  }

  getItems() {
    return this._items;
  }
  
  getReportById(body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.REPORTSCHEMAS}/report`), body);
  }
  
  getReportData(body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.REPORTSCHEMAS}/data`), body);
  }
  
  getMenuItems() {
    return this.http.post(this.constantService.getUrl(`${this.constantService.REPORTSCHEMAS}/menuItems`),{});
  }
}